import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { deleteTaxRate } from "../../api/apiTax";
import parseError from "../../utils/parseError";

export const useDeleteTaxRate = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteTaxRateMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteTaxRate,
        onSuccess: (res) => {
            toast.success(res.message || "Tax rate deleted successfully");
            queryClient.invalidateQueries(["tax-rates"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to delete tax rate");
        },
    });

    return { deleteTaxRateMutate, isDeleting };
};
